import { render, staticRenderFns } from "./VlChatClient.vue?vue&type=template&id=a1c3c2c6"
import script from "./VlChatClient.vue?vue&type=script&lang=js"
export * from "./VlChatClient.vue?vue&type=script&lang=js"
import style0 from "./VlChatClient.vue?vue&type=style&index=0&id=a1c3c2c6&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports